import * as types from './actionTypes';
import mensagemApi from '../api/mensagemApi'
import ConfigD from '../util/ConfigD';


export function ValidarSuccess(mensagem) {
    
    return { type: types.VALIDAR_CODIGO, mensagem }
}

export function Validar(parametros) {
   
    return function (dispatch) {
        return mensagemApi.Validar(parametros).then(mensagem => {
            
            dispatch(ValidarSuccess(mensagem));
        }).catch(error => {
            throw (error);
        });
    };
}

export function ObterMensagemPorProtocoloSenhaSuccess(mensagem) {

    //Para controle do download.aspx
    ConfigD.setCookie('protpass', mensagem.dado[0].mAtendimento.mProtocolo, 1);
    
    return { type: types.CONSULTAR_MENSAGEM_PROTOCOLO_SENHA, mensagem }
}

export function ObterMensagemPorProtocoloSenha(parametros) {
   
    return function (dispatch) {
        return mensagemApi.ObterMensagemPorProtocoloSenha(parametros).then(mensagem => {
            
            dispatch(ObterMensagemPorProtocoloSenhaSuccess(mensagem));
        }).catch(error => {
            throw (error);
        });
    };
}

export function SolicitarAutorizacaoPorProtocoloSenhaSuccess(mensagem) {
    
    return { type: types.CONSULTAR_MENSAGEM_PROTOCOLO_SENHA, mensagem }
}

export function SolicitarAutorizacaoPorProtocoloSenha(parametros) {
   
    return function (dispatch) {
        return mensagemApi.SolicitarAutorizacaoPorProtocoloSenha(parametros).then(mensagem => {
            
            dispatch(SolicitarAutorizacaoPorProtocoloSenhaSuccess(mensagem));
        }).catch(error => {
            throw (error);
        });
    };
}

export function CadastrarSuccess(mensagem) {
    
    return { type: types.CADASTRAR_MENSAGEM, mensagem }
}

export function Cadastrar(parametros) {
    
    return function (dispatch) {
        return mensagemApi.Cadastrar(parametros).then(mensagem => {
            
            dispatch(CadastrarSuccess(mensagem));
        }).catch(error => {
            throw (error);
        });
    };
}

export function tramitarSuccess(mensagem) {
    
    return { type: types.TRAMITAR_MENSAGEM, mensagem }
}

export function tramitar(mensagem) {
    
    return function (dispatch) {
        return mensagemApi.Tramitar(mensagem).then(mensagem => {
            
            dispatch(tramitarSuccess(mensagem));
        }).catch(error => {
            throw (error);
        });
    };
}


/** WEBPACK FOOTER **
 ** ./src/components/actions/mensagemActions.js
 **/